import React from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import staffStyles from "pages/Staff/staff.module.scss";
import SafeHtml from "components/SafeHtml";

function CompanyBrandingInfoModal({ t, isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={staffStyles.modal_container}>
          <p>{t("accountPreferences.companyBrandingSettingsSubHeading")}</p>
          <div className="page-warning-container container mt-3 pl-0">
            <div className="page-warning-bg">
              <div className="page-warning-text">
                <SafeHtml
                  as="span"
                  html={t("accountPreferences.companyBrandingNote")}
                />
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(CompanyBrandingInfoModal);
